import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

const buildUrl = (path, params) => {
    const query = new URLSearchParams(params).toString();
    return `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${path}?${query}`;
};

export const fetchOrderCountByDocType = async ({ from, to }) => {
    if (!from || !to) return [];

    const url = buildUrl(
        oAuthServiceConfig.getOrderCountByDocType,
        { from, to }
    );

    const res = await OAuthService.getList(url);
    return res?.data || [];
};

export const fetchOrderCountByVendor = async ({ from, to }) => {
    if (!from || !to) return [];

    const url = buildUrl(
        oAuthServiceConfig.getOrderCountByVendor,
        { from, to }
    );

    const res = await OAuthService.getList(url);
    return res?.data || [];
};

export const fetchOrderCountByCategory = async ({ from, to }) => {
    if (!from || !to) return [];

    const url = buildUrl(
        oAuthServiceConfig.getOrderCountByCategory,
        { from, to }
    );

    const res = await OAuthService.getList(url);
    return res?.data || [];
};

export const fetchSalesByCategoryGroup = async ({ from, to }) => {
    if (!from || !to) return [];

    const url = buildUrl(
        oAuthServiceConfig.getOrderCountByCategoryGroup,
        { from, to }
    );

    const res = await OAuthService.getList(url);
    return res?.data || [];
};

export const fetchTerritorySalesByCategoryGroup = async ({ from, to }) => {
    if (!from || !to) return [];

    const url = buildUrl(
        oAuthServiceConfig.getTerritoryOrderCountByCategoryGroup,
        { from, to }
    );

    const res = await OAuthService.getList(url);
    return res?.data || [];
};

export const fetchPartnerSalesByTerritory = async ({
    territoryId,
    from,
    to,
}) => {
    if (!territoryId || !from || !to) return [];

    const url = buildUrl(
        oAuthServiceConfig.getPartnerOrderCountByTerritory,
        { territory: territoryId, from, to }
    );

    const res = await OAuthService.getList(url);
    return res?.data || [];
};

export const fetchActivePartnersByTerritory = async ({ territoryId }) => {
    if (!territoryId) return [];

    const url = buildUrl(
        oAuthServiceConfig.findByTerritoryAndActiveTrueOrderById,
        { territory: territoryId }
    );

    const res = await OAuthService.getList(url);
    return res?.data?._embedded?.companies || [];
};

export const fetchActiveRegularPartners = async () => {
    const url = buildUrl(
        oAuthServiceConfig.findCompaniesByActiveAndType,
        {
            active: true,
            customerType: 'REGULAR'
        }
    );

    const res = await OAuthService.getList(url);
    return res?.data?._embedded?.companies || [];
};

export const fetchMonthlySalesByCategoryGroup = async ({ from, to }) => {
    if (!from || !to) return [];

    const url = buildUrl(
        oAuthServiceConfig.getMonthlyOrderCountByCategoryGroup,
        { from, to }
    );

    const res = await OAuthService.getList(url);
    return res?.data || [];
};

export const fetchTotalBudgetByCategoryGroup = async ({ year }) => {
    if (!year) return {};

    const url = buildUrl(
        oAuthServiceConfig.getTotalBudgetByCategoryGroup,
        { year }
    );

    const res = await OAuthService.getList(url);
    return res?.data || {};
};

export const fetchTerritoryBudgetByYear = async ({ year }) => {
    if (!year) return [];

    const url = buildUrl(
        oAuthServiceConfig.getTerritoryBudgetByYear,
        { year }
    );

    const res = await OAuthService.getList(url);
    return res?.data || [];
};

export const fetchCountryBudgetByYear = async ({ year }) => {
    if (!year) return [];

    const url = buildUrl(
        oAuthServiceConfig.getCountryBudgetByYear,
        { year }
    );

    const res = await OAuthService.getList(url);
    return res?.data || [];
};


export const fetchLastBookingWeek = async () => {

    const url = buildUrl(
        oAuthServiceConfig.getLastBookingWeek,
        {}
    );

    const res = await OAuthService.getList(url);
    return res?.data || null;
};

export const fetchCustomerBudgets = async ({ year, type }) => {
    if (!year) return [];
    const url = buildUrl(
        oAuthServiceConfig.getCustomerBudgets,
        { year, type }
    );

    try {
        const res = await OAuthService.getList(url);
        return res?.data || [];
    } catch (error) {
        console.error("Error fetching customer budgets:", error);
        throw error;
    }
};